  <template>
  <div id="stand-saloons">
    <div class="content-wrapper">
      <portal to="action-buttons"></portal>
      <div class="content animated fadeIn">
        <div class="card" style="padding:0px; box-shadow:unset;">
          <div class="card-header header-elements-inline" style="padding-bottom:0px;">
            <h5 class="card-title">{{this.$t('event.components.participants.navbar.category')}}</h5>

            <div class="header-elements">
              <el-button-group>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.helpdesk')" placement="top">
                  <el-button @click="$helpMe(null)" icon="fas fa-life-ring" size="mini"></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.refresh')" placement="top">
                  <el-button
                    icon="fas fa-redo-alt"
                    size="mini"
                    @click="$store.dispatch('getPacketCategories')"
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.buttons.addNew')" placement="top">
                  <el-button
                    icon="fas fa-plus"
                    size="mini"
                    type="primary"
                    @click="updateForm = null;
                modalVisible = true;"
                  ></el-button>
                </el-tooltip>
              </el-button-group>
            </div>
          </div>

          <el-table
            v-loading="$store.state.packetcategory.loading"
            ref="multipleTable"
            :data="$store.state.packetcategory.items"
            style="width: 100%"
          >
            <el-table-column :label="$t('event.table.sequence')" property="orderNO" min-width="50"></el-table-column>
            <el-table-column :label="$t('event.table.title')" property="title" min-width="200"></el-table-column>

            <el-table-column align="center" :label="$t('event.table.processes')" width="150" fixed="right">
              <template slot-scope="scope">
                <el-tooltip class="item" effect="dark" :content="$t('event.table.edit')" placement="top">
                  <el-button
                    type="primary"
                    icon="fas fa-pen"
                    circle
                    size="mini"
                    @click="
                      updateForm = JSON.parse(JSON.stringify(scope.row));
                      modalVisible = true;
                    "
                  ></el-button>
                </el-tooltip>
                <el-tooltip class="item" effect="dark" :content="$t('event.table.delete')" placement="top">
                  <el-popconfirm
                    @confirm="deleteItem(scope.$index)"
                    :confirmButtonText="$t('event.variables.yes')"
                    :cancelButtonText="$t('event.buttons.cancel')"
                    icon="el-icon-info"
                    iconColor="red"
                    :title="$t('event.textbox.toDelete')"
                  >
                    <el-button
                      slot="reference"
                      type="danger"
                      icon="fas fa-trash"
                      circle
                      size="mini"
                    ></el-button>
                  </el-popconfirm>
                </el-tooltip>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>

    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="modalVisible"
      :title="$t('event.tags.editPack')"
      width="60%"
      :append-to-body="true"
    >
      <PacketCategoryAddUpdate
        @deleteMe="deleteItem"
        @closeMe="modalVisible = false"
        @itemUpdated="itemUpdated"
        @itemAdded="itemAdded"
        :data="updateForm"
      />
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import PageCountInfo from "./PageCountInfo";
import PacketCategoryAddUpdate from "./PacketCategoryAddUpdate";
import $ from "jquery";
export default {
  components: { PageCountInfo, PacketCategoryAddUpdate },
  name: "PacketCategories",
  data() {
    return {
      modalVisible: false,
      updateForm: null,
      isFilterEnabled: false,
      timeout: null,
      excelDialog: false,
      helpUrl: this.$helpUrl + "questionlibrary",
    };
  },
  methods: {
    handleSizeChange(take) {
      this.$store.commit("setSubEventsTake", take);
    },
    handleCurrentChange(page) {
      $("html, body").animate({ scrollTop: 0 }, 350);
      this.$store.commit("setSubEventsPage", page);
    },
    itemUpdated(item) {
      this.$store.dispatch("getPacketCategories");
    },
    itemAdded(item) {
      this.$store.dispatch("getPacketCategories");
    },
    deleteItem(index) {
      this.$store.dispatch("deletePacketCategory", { index, context: this });
    },
    tableRowClassName({ row, rowIndex }) {
      if (row.isActive) {
        return "row-active";
      }
      return "row-passive";
    },
    statusChanged(value, index) {
      this.$store.dispatch("toggleSubEvents", { index, value });
    },
  },
  mounted() {
    this.$store.dispatch("getPacketCategories");
  },
  created() {},
  computed: {
    skip() {
      return (
        (this.$store.state.stands.filter.page - 1) *
        this.$store.state.stands.filter.take
      );
    },
    take() {
      return this.skip + this.$store.state.stands.items.length;
    },
  },
  watch: {
    "$store.state.stands.filter.searchTerm": function () {
      clearTimeout(this.timeout);
      this.timeout = setTimeout(() => {
        this.$store.dispatch("getPacketCategories");
      }, 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/PacketCategory.vue